/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {APP_URL, toAbsoluteUrl, useAuth} from 'shared'

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-5'>
        <div className='menu-content d-flex align-items-center px-5'>
          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.name}
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {currentUser?.email}
            </a>
            <div className='fw-bold d-flex align-items-center fs-6 mt-3'>
              Организация:
            </div>
            <a href='#' className='fw-bold text-muted fs-7'>
              {currentUser?.organization.name}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={APP_URL.PROFILE_OVERVIEW} className='menu-link px-5'>
          Мой профиль
        </Link>
      </div>
      
      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Выйти
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
